import { CanActivateFn, Router } from '@angular/router';

import { AppSessionService } from '../session/app-session.service';
import { inject } from '@angular/core';
import { isAfter, } from 'date-fns';
import { AppAuthService } from './app-auth.service';
import { catchError, map, of } from 'rxjs';

export const mustBeLogged: CanActivateFn = (route, state) => {
  const appSession = inject(AppSessionService);
  const router = inject(Router);
  const authService = inject(AppAuthService);

  if (appSession.accessToken && appSession.expiresAt && isAfter(appSession.expiresAt, new Date())) {
    return true;
  } else if (appSession.accessToken && appSession.expiresAt && !isAfter(appSession.expiresAt, new Date())) {
    return authService.refreshToken().pipe(
      map(() => true),
      catchError(() => {
        void router.navigate(['/account/login']);
        return of(false);
      })
    );
  } else {
    void router.navigate(['/unauthorized']);
    return false;
  }
};

export const appRouteGuardFn: CanActivateFn = (route, state) => {
  // const appInitializer = inject(AppInitializer);
  // const injector = inject(Injector);
  // return appInitializer.initialized$.pipe(
  //   filter(isInitialized => isInitialized === true),
  //   map(() => {
  //     console.log('app auth guard');
  //     const _sessionService = injector.get(AppSessionService);
  //     const _router = injector.get(Router);
  //     const _permissionChecker = injector.get(AbpPermissionCheckerService);
  //
  //     // if (!_sessionService.user) {
  //     //   console.log('NOT USER FOUND ON SESSION');
  //     //   void _router.navigate(['/account/login']);
  //     //   return false;
  //     // }
  //
  //     if (!route.data || !route.data['permission']) {
  //       return true;
  //     }
  //
  //     if (_permissionChecker.isGranted(route.data['permission'])) {
  //       console.log('PERMISSION NON  GRANTED to ', route.data['permission'])
  //       return true;
  //     }
  //
  //     void _router.navigate([selectBestRoute(_sessionService, _permissionChecker)]);
  //     return false;
  //   })
  //
  // );
  //TODO: da rivedere
  return true;
};


// const selectBestRoute = (_sessionService: AppSessionService, _permissionChecker: AbpPermissionCheckerService): string => {
//   // if (!_sessionService.user) {
//   //   return '/account/login';
//   // }
//
//   // if (_permissionChecker.isGranted('Pages.Users')) {
//   //   return '/app/admin/users';
//   // }
//
//   return '/home';
// }
